import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { CreationTypes, UserInfoType } from '../../types/loginTypes';
import { EMAIL_ADDRESS, PROFILE_DETAILS } from '../../routes/routes';
import { setUserRegisterToLS } from '../../helpers/localstorage-helper';
import { ErrorToast } from '../../components';
import axios from 'axios';

interface GetReferrerValidationType {
  referrerId: number | null;
  result: any;
  history: any;
}

interface GetReferrerUsernameValidationType {
  username: string | null;
  result: any;
  history: any;
}

export const getReferrerValidation = createAsyncThunk(
  'auth/getReferrerValidation',
  async (
    { referrerId, result, history }: GetReferrerValidationType,
    { rejectWithValue, getState, dispatch }
  ) => {
    const {
      lot_number: lotNumber,
      captcha_output: captchaOutput,
      pass_token: passToken,
      gen_time: genTime
    } = result;

    try {
      const state = getState() as RootState;

      const creationType = state.auth.register?.user?.creationType;
      const token = state.auth.register?.token;

      const { data } = await axios.get(
        `/authorization/signup/refferer/${referrerId}/validate`,
        {
          params: {
            lotNumber,
            captchaOutput,
            passToken,
            genTime
          }
        }
      );

      if (creationType === CreationTypes.Google) {
        dispatch(
          socialReferrer({
            referrerId,
            token,
            history
          })
        );
      } else {
        history.push({
          pathname: EMAIL_ADDRESS
        });

        setUserRegisterToLS({
          referrerId,
          user: { creationType: CreationTypes.Local },
          referrer: {
            name: data.data.name,
            surname: data.data.surname
          }
        });

        return {
          referrerId,
          user: { creationType: CreationTypes.Local },
          referrer: {
            name: data.data.name,
            surname: data.data.surname
          }
        };
      }
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

export const getReferrerUsernameValidation = createAsyncThunk(
  'auth/getReferrerUsernameValidation',
  async (
    { username, result, history }: GetReferrerUsernameValidationType,
    { rejectWithValue, getState, dispatch }
  ) => {
    const {
      lot_number: lotNumber,
      captcha_output: captchaOutput,
      pass_token: passToken,
      gen_time: genTime
    } = result;

    try {
      const state = getState() as RootState;

      const creationType = state.auth.register?.user?.creationType;
      const token = state.auth.register?.token;

      const { data } = await axios.get(`/authorization/signup/refferer`, {
        params: {
          username,
          lotNumber,
          captchaOutput,
          passToken,
          genTime
        }
      });

      if (creationType === CreationTypes.Google) {
        dispatch(
          socialReferrer({
            referrerId: data.data.id,
            token,
            history
          })
        );
      } else {
        history.push({
          pathname: EMAIL_ADDRESS
        });

        setUserRegisterToLS({
          referrerId: data.data.id,
          user: { creationType: CreationTypes.Local },
          referrer: {
            name: data.data.name,
            surname: data.data.surname
          }
        });

        return {
          referrerId: data.data.id,
          user: { creationType: CreationTypes.Local },
          referrer: {
            name: data.data.name,
            surname: data.data.surname
          }
        };
      }
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

interface SocialReferrerType {
  referrerId: number | null;
  token: any;
  history: any;
}

export const socialReferrer = createAsyncThunk(
  'auth/socialReferrer',
  async (
    { referrerId, token, history }: SocialReferrerType,
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        `/authorization/signup/social/refferer`,
        {
          referrerId: referrerId ? Number(referrerId) : null,
          token
        }
      );

      const user = response.data.data.user as UserInfoType;

      setUserRegisterToLS({ referrerId, user, token });

      history.push(PROFILE_DETAILS);

      return { referrerId, user, token };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
